import React, { useState } from "react";
import brokenRice2 from "../../../assets/images/greenshine/brokenrice/Broken-Rice1.jpg";
import brokenRice1 from "../../../assets/images/greenshine/brokenrice/broken-rice.jpg";
import brokenRice3 from "../../../assets/images/greenshine/brokenrice/broken-rice3.jpeg";
import rice1 from "../../../assets/images/greenshine/rice/IMG-29f5d5569e7ff45df82c3d4320056d9b-V.jpg";
import rice2 from "../../../assets/images/greenshine/rice/IMG-8b7712f6f55cacf0ab730df2c9bdf071-V.jpg";
import rice3 from "../../../assets/images/greenshine/rice/IMG-a5cf4bc52df4765456fcb0691ac43f24-V.jpg";

import yellowmaize2 from "../../../assets/images/greenshine/yellowmize/yellow-corn.jpg";
import yellowmaize1 from "../../../assets/images/greenshine/yellowmize/yellow-maize-1.jpg";
import yellowmaize3 from "../../../assets/images/greenshine/yellowmize/yellowmaize3.jpg";


import matpe from  "../../../assets/images/greenshine/beans/matpe.jpg";
import greenBean01 from "../../../assets/images/greenshine/beans/green-bean-1.png";
import greenBean02 from "../../../assets/images/greenshine/beans/green-bean-2.jpg";
const ProductAbout = () => {
  const Data = [
    // {
    //   id: 1,
    //   title: "Paddy",
    //   text: "Mung beans are an important type of bean in pulse production. They can be grown in soils with limited moisture and plant nutrients. The vitamins present in mung bean protein are essential for humans, as it contains a significant amount of minerals. Mung beans are typically planted in winter, and in certain parts of Myanmar, they are also cultivated during the rainy season, primarily in the Bago Region and Irrawaddy Region. Furthermore, mung beans are a crop with a presence in the foreign market",
    //   image1: Paddy1,
    //   image2: Paddy2,
    //   image3: Paddy4,
    // },
    {
      id: 2,
      title: "Rice",
      text: `Rice is a staple food in Myanmar and a fundamental part of its culture and economy. It is a 
major dietary component for the population and is deeply intertwined with daily life. Myanmar's 
favorable climate and geographic diversity make it well-suited for rice cultivation.
Myanmar has a significant role in global rice production and exports. The country has 
traditionally been one of the world's largest rice exporters. The agriculture sector, including rice, 
employs a substantial portion of the population, especially in rural areas.
Myanmar's rice market share and percentage of global exports can vary from year to year 
based on factors such as production, demand, international trade agreements, and government 
policies. As of 2021, Myanmar's share of the global rice market had been fluctuating due to 
factors like changing trade dynamics and internal challenges.`,
      image1: rice2,
      image2: rice1,
      image3: rice3,
    },
    {
      id: 3,
      title: "Broken Rice ",
      text: `Myanmar is undertaking the development of the agricultural sector as a national responsibility. 
Despite numerous modifications in rice cultivation methods over the years, the central objective 
remains consistent: to enhance yield. Countries such as the People's Republic of China, 
Thailand, India, and Vietnam excel in producing high-quality rice, securing their positions in the 
global rice market. Within rice development, the focus has shifted beyond yield alone; 
enhancing rice quality now plays a pivotal role. However, a glance at Myanmar's present rice 
production reveals a scarcity of high-quality rice varieties being chosen and cultivated. Reports 
indicate that Myanmar's international rice export market comprises primarily low-grade rice, 
accounting for only around 25% of the market. Such rice is not categorized as high-quality 
(Premium Rice) and therefore does not command a competitive price. Offering high-quality rice 
is an entitlement for consumers—a choice they should rightfully have. Consumers, even if faced
with a higher price tag, tend to opt for quality that aligns with their preferences, bolstering 
market demand. Consequently, rice cultivators must diligently attend to the aspect’s consumers 
predominantly value.`,
      // image: Image3,
      image1: brokenRice3,
      image2: brokenRice1,
      image3: brokenRice2,
    },
    {
      id: 4,
      title: "Yellow Maize ",
      text: `Corn, known as maize or corn in the English language, was cultivated by the people of 
Mesoamerica in prehistoric times. Across southern and central Mexico, the Aztecs and Mayans 
cultivated various types of corn for cooking and consumption, utilizing a process known as 
nixtamalization. This involved soaking the corn in lime juice and peeling it. Subsequently, corn 
spread throughout the Americas. Between 1250 and 1700, corn became widely available across
the continent. In densely populated and significant regions, an extensive trade network centered
around surplus corn and its diverse forms was established. When Europeans first encountered 
the Americas in the late 15th and early 16th centuries, explorers and traders introduced corn to 
Europe and other countries. Maize has gained global popularity due to its adaptability to 
different climates. It can be boiled and consumed directly or processed into various foods. 
Maize is transformed into multiple forms, including breakfast foods like cornflakes, corn oil, corn 
soup, boiled corn, and corn flour, which are produced and sold.`,
      // image: Image5,
      image1: yellowmaize1,
      image2: yellowmaize2,
      image3: yellowmaize3,
    },
    {
      id: 5,
      title: "Bean & Pulses ",
      text: `A pulse is the edible seed from a legume plant. Pulses include beans, lentils, and peas. For 
example, a pea pod is a legume, but the pea inside the pod is the pulse.
 A bean is a type of plant seed or its pod that belongs to the legume family. Legumes are plants 
that produce seeds in pods, and beans are a common form of legume. They come in various 
sizes, shapes, and colors, and they are used as a food source due to their high protein and 
nutrient content. Some common types of beans include kidney beans, black beans, pinto beans,
navy beans, and cannellini beans, among others. Beans are often used in cooking, both as a 
main ingredient in dishes like stews and soups, and as a side dish.
 Pulses are a subset of legumes that are harvested for their dry edible seeds. They are also 
known as "grain legumes." Pulses include a wide variety of crops, such as beans, lentils, 
chickpeas, and dry peas. These crops are grown for their seeds, which are dried and used as a 
protein-rich food source. Pulses are valuable in diets around the world, especially in regions 
where animal protein sources are less available. They are known for their nutritional benefits, 
including being a good source of protein, dietary fiber, vitamins, and minerals.`,
      // image: Image4,
      // image1: bean1,
      image2: greenBean01,
      image3: matpe,
    },
  ];
  // Set the active tab using state
  const [activeTab, setActiveTab] = useState(0);
  // Function to handle tab selection
  const handleTabClick = (index) => {
    setActiveTab(index);
  };

  return (
    <div className="my-20 px-6">
      <ul className="grid grid-cols-2 md:grid-cols-5  gap-5 ">
        {Data?.map((tab, index) => (
          <li
            key={index}
            className={`text-[16px] font-semibold border-b-4 cursor-pointer rounded-t-xl
               hover:bg-green-500 px-4 py-4 transition duration-500 titlefont ${
                 activeTab === index &&
                 " border-green-500 text-white bg-green-500"
               }`}
            onClick={() => handleTabClick(index)}>
            {tab?.title}
          </li>
        ))}
      </ul>
      <div className="grid lg:grid-cols-1   h-auto gap-14  z-50">
        {/* <div className="mt-8 order-2 lg:order-1 "> */}
        {/* <h1 className="text-2xl  font-semibold text-green-500 mb-6">
            {" "}
            {Data[activeTab].title}
          </h1>
          <p className="opacity-70 text-[15px] leading-8 ">
            {Data[activeTab].text}
          </p> */}

        {/* <p className="opacity-70 text-[15px] mt-2 ">{Data[activeTab].text1}</p> */}
        {/* <p className="opacity-70 text-[15px] mt-2 ">{Data[activeTab].text2}</p> */}
        {/* <p className="opacity-70 text-[15px] mt-2 ">{Data[activeTab].text3}</p> */}
        {/* </div> */}
        {/* <div className="mt-10 order-1 lg:order-2">
          <img
            src={Data[activeTab].image}
            className="rounded-xl w-full lg:h-[700px] h-auto object-cover"
            alt=""
          />
        </div> */}
        <div
          id="lookbook"
          className="grid md:grid-cols-3 grid-cols-1 gap-2 px-2 md:px-4 lg:px-10 mt-10">
          <div className="md:col-span-3  relative w-full">
            {Data[activeTab]?.image1 && (
              <img
                src={Data[activeTab]?.image1}
                className="h-[25.3rem]  object-center  rounded-t-2xl object-cover w-full"
                alt=""
              />
            )}
          </div>
          {/* <div className=" col-span-1 relative ">
        <img
          src="https://secretbottleshop.co.uk/cdn/shop/files/Basil-Hayden-Bourbon-Lifestyle-1_786x786.png?v=1685031048"
          className="h-[21.3rem]  object-center object-cover w-full"
          alt=""
        />
        <div className="absolute top-0 right-0 text-end ">
          <h1 className="text-4xl text-white font-['Open_Sans'] max-w-sm px-8 pt-8 font-bold ">
            Discover Basil Hayden
          </h1>
        </div>
      </div> */}
          <div className=" md:col-span-1 relative ">
            <img
              src={Data[activeTab]?.image2}
              className="h-[21.3rem] object-center object-cover w-full"
              alt=""
            />
            {/* <div className="absolute top-0 right-0 text-end ">
              <h1 className="text-4xl text-white font-['Open_Sans'] max-w-sm px-8 pt-8 font-bold ">
                The Perfect Gift
              </h1>
            </div> */}
          </div>
          <div className="md:col-span-2  relative ">
            <div>
              <img
                src={Data[activeTab]?.image3}
                className="h-[21.3rem] object-cover  w-full"
                alt=""
              />

              {/* <div className="absolute top-0 right-0 text-end ">
                <h1 className="text-4xl text-white font-['Open_Sans'] max-w-sm px-8 pt-8 font-bold ">
                  Worth Trying Selection
                </h1>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductAbout;
